module.exports = __webpack_public_path__ + "8e1f311cd56ec04eedd0958a6b60d5da.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SG.svg
// module id = 4mLE
// module chunks = 0